import Hls from 'hls.js';
import { getQueryParam } from '../../helpers';

interface VideoCapabilities {
  hlsSupport: 'native' | 'hlsjs' | 'vhs';
}

const FORCE_HLS_TECH = getQueryParam('force_hls_tech');

export function getVideoCapabilities(): VideoCapabilities {
  const nativeHlsSupported = isNativeHlsSupported();
  const hlsJsSupported = Hls.isSupported();

  if (FORCE_HLS_TECH) {
    return {
      hlsSupport: FORCE_HLS_TECH as VideoCapabilities['hlsSupport'],
    };
  }

  let hlsSupport: VideoCapabilities['hlsSupport'];

  // prioritize hlsjs over native hls because with native support it seems
  // to appear some seconds delay when playing the video
  if (hlsJsSupported) {
    hlsSupport = 'hlsjs';
  } else if (nativeHlsSupported) {
    hlsSupport = 'native';
  } else {
    hlsSupport = 'vhs';
  }

  return {
    hlsSupport,
  };
}

function isNativeHlsSupported(): boolean {
  try {
    if (typeof document === 'undefined') {
      return false;
    }

    const el = document.createElement('video') as any;
    if (typeof el.canPlayType !== 'function') {
      return false;
    }
    return Boolean(el.canPlayType('application/vnd.apple.mpegURL'));
  } catch {
    return false;
  }
}
